import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom"
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import { ReactComponent as MenuIcon } from '../../../assets/menu.svg';
import ProfileMenu from '../../../assets/Icons/profile'
import image from "../../../assets/girl-power.png";
import Ouvidoria from '../../../assets/Icons/ouvidoria'
import Users from '../../../assets/Icons/users'
import LoginIconJS from '../../../assets/Icons/loginIcon'
import LogOut from '../../../assets/Icons/logout'

import DenunciationsIcon from '../../../assets/Icons/denunciationsIcon';

import './styles.css';
import { withFirebase } from '../../../contexts/Firebase'

import Contact from '../../Contact';
import About from '../../About';
import Callout from '../../Callout';

function HeaderLink({ onClick, title, Icon, pathname }) {
    return (
        <div
            className={'label-container'}
            onClick={onClick}
            id={title+'-button'}
        >
            <Icon color={window.location.pathname === pathname? '#C36869' :'white'}className='label-icon'/>
            <label className={window.location.pathname === pathname? 'label-title-adm-clicked' :'label-title-adm'}>{title}</label>
        </div>
    )
}

function Header(props){
    const [{ width }, setDimension] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [dropMenuOpen, setDropMenuOpen] = useState(false);
    const [curCallout, setCurCallout] = useState(0);
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);

    const[adm] = useState(localStorage.getItem('adm'))

    const location = useLocation()

    function handleOuvidoria(){
        history.push('/create-ouvidoria')
    }

    function handleListProfiles(){
        history.push('/list-profiles')
    }

    function handleListDenunciations(){
        history.push('/list-denunciations');
    }

    function handleProfileData(event){
        // history.push('/profile')
        setAnchorEl(event.currentTarget);

    }
    const handleClose = () => {
        setAnchorEl(null);
    }
    const handleProfile = () =>{
        history.push('/admin-profile')
    }

    const updateWindowDimensions = () => {
        setDimension({ width: window.innerWidth, height: window.innerHeight });
    };

    useEffect(() => {
        window.addEventListener('resize', updateWindowDimensions);
        return () => window.removeEventListener('resize', updateWindowDimensions);
    }, []);

    useEffect(() => {
        if(width > 540 && dropMenuOpen) {
            setDropMenuOpen(false);
        } else if(width < 540 && curCallout) {
            setCurCallout(0);
        }
    }, [width, dropMenuOpen, curCallout]);

    const handleShowMap = () =>{
        history.push('/')
    }

    return (
        <header>
            <div id="geral">
                <div className="left-content crsptr" onClick={handleShowMap}>
                    <div id="boximg">
                        <img src={image} className="img_logo" alt="logo do aplicativo" id="img_logo" />
                    </div>           
                    <div className="titulo">
                        <h1 className="titulo1">APLICATIVO DE </h1>
                        <h1 className="titulo2">SEGURANÇA DA MULHER</h1>
                    </div>
                </div>
                <div className='right-content'>
                    {width > 540 ? // pc
                        <>
                            <HeaderLink title='Denúncias' Icon={DenunciationsIcon} onClick={handleListDenunciations} pathname="/list-denunciations"/>
                            {adm === 'true' || adm === true ? 
                                <HeaderLink title='Cadastrar Ouvidoria' Icon={Ouvidoria} onClick={handleOuvidoria} pathname="/create-ouvidoria"/>: null
                            }
                            <HeaderLink title='Usuários' Icon={Users} onClick={handleListProfiles} pathname="/list-profiles"/>
                            <HeaderLink title='Perfil' Icon={LoginIconJS} onClick={handleProfileData} pathname="/admin-profile"/>
                        </>
                    : // mobile
                        <div
                            id='menu-button'
                            className={ dropMenuOpen ?  'menu-button-active' : 'menu-button' }
                            onClick={() => setDropMenuOpen(!dropMenuOpen)}
                        >
                            <MenuIcon className='menu-icon'/>
                        </div>
                    }
                </div>
            </div>
            <div
                id='menu'
                className= {dropMenuOpen ? 'menu-open' : 'menu-closed'}
            >
                {adm === 'true' || adm === true ? 
                    <HeaderLink title='Cadastrar Ouvidoria' Icon={Ouvidoria} onClick={handleOuvidoria} pathname="/create-ouvidoria"/>: null}
                <HeaderLink title='Usuários' Icon={Users} onClick={handleListProfiles} pathname="/list-profiles"/>
                <HeaderLink title='Perfil' Icon={LoginIconJS} onClick={handleProfileData} pathname="/admin-profile"/>

            </div>
            {curCallout ?
                <Callout onClickOutSide={() => setCurCallout(0)}>
                    {
                        {
                            1: <Contact/>,
                            2: <About/>,
                        }[curCallout]
                    }
                </Callout>
            : null }

                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {
                        location.pathname !== '/admin-profile'?
                            <MenuItem id='perfil-button' onClick={handleProfile}>
                                <ProfileMenu/> &nbsp; Meu perfil
                            </MenuItem>
                            :
                            null
                    }

                    <MenuItem id='sair-button'onClick={()=> props.firebase.doSignOut()}>
                        <LogOut/> &nbsp; Sair
                    </MenuItem>
                    
                    
                </Menu>
        </header>
    )
}

export default withFirebase(Header)